/* Truefit order builder: photo gallery (thumbnails, arrows, keyboard, swipe) and the page's call-to-action buttons. Standalone, no dependencies. */
(function () {
  'use strict';
  var g = document.getElementById('tb-gal'); if (!g) return;
  var $ = function (s) { return g.querySelector(s); };
  var th = Array.prototype.slice.call(g.querySelectorAll('.tb-gt')), img = $('#tb-gal-img'), cnt = $('#tb-gal-count'), stage = $('.tb-gal-stage'), cur = 0;
  if (!th.length || !img) return;
  function show(i, focusThumb) {
    cur = (i + th.length) % th.length;
    th.forEach(function (b, k) { var on = k === cur; b.classList.toggle('is-on', on); b.setAttribute('aria-current', on ? 'true' : 'false'); });
    img.src = th[cur].getAttribute('data-src'); img.alt = th[cur].getAttribute('data-alt') || '';
    if (cnt) cnt.textContent = (cur + 1) + ' / ' + th.length;
    var bx = th[cur], tr = bx.parentNode;
    if (tr.scrollWidth > tr.clientWidth) tr.scrollLeft = bx.offsetLeft - (tr.clientWidth - bx.offsetWidth) / 2;
    if (focusThumb) bx.focus();
  }
  g.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('.tb-gt,[data-gal]') : null; if (!t) return;
    if (t.classList.contains('tb-gt')) show(th.indexOf(t));
    else show(cur + parseInt(t.getAttribute('data-gal'), 10));
  });
  g.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); show(cur + 1, true); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); show(cur - 1, true); }
  });
  var x0 = null;
  stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  stage.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); }, { passive: true });
  show(0);
})();

/* Every [data-tfc2-cta] button on the page scrolls to the start of the customizer.
   Uses scrollIntoView (works whichever element scrolls, the window or an inner container); the 90px offset is the target's scroll-margin-top. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-tfc2-cta]') : null; if (!a) return;
    var t = document.getElementById('tb-custhead') || document.getElementById('tb-s-players') || document.getElementById('tfc2-builder');
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });
})();
